import React from 'react';
import './index.scss';

const DataLoader = () => {
  return <div className="dot-flashing"></div>;
};

export default DataLoader;
